import throttle from 'lodash/throttle';

/*
Sticky Nav
=================================================================
*/
/* eslint-disable */

export default (function () {
  const elements = {
    body: document.body,
    topBar: document.querySelector('[data-component="topbar"]'),
    topBarState: document.querySelector('[data-component-topbar-state]'),
  };
  const states = {
    mobile: 'data-component-topbar-state',
    topbarState: {
      IDLE: 'IDLE',
      VISIBLE: 'VISIBLE',
      HIDDEN: 'HIDDEN',
    },
    visible: 'visible',
    hidden: 'hidden',
    currentScroll: 0,
    lastScroll: 0,
  };

  const classes = {
    scrollUp: 'scroll-up',
    scrollDown: 'scroll-down',
    fixedNav: 'pos-fixed',
  };

  function hideMenu() {
    elements.body.classList.remove(classes.scrollUp);
    elements.body.classList.add(classes.scrollDown);
    elements.topBar.setAttribute(states.mobile, states.topbarState.HIDDEN);
    elements.topBar.classList.remove(classes.fixedNav);
  }

  function showMenu() {
    elements.topBar.setAttribute(states.mobile, states.topbarState.VISIBLE);
    elements.body.classList.remove(classes.scrollDown);
    elements.body.classList.add(classes.scrollUp);
    elements.topBar.classList.add(classes.fixedNav);
  }

  const applyStickyNav = () => {
    states.currentScroll = window.pageYOffset;

    if (states.currentScroll <= 0) {
      elements.body.classList.remove(classes.scrollUp);
      elements.topBar.setAttribute(states.mobile, states.topbarState.IDLE);
      return;
    }

    if (
      states.currentScroll > states.lastScroll &&
      !elements.body.classList.contains(classes.scrollDown)
    ) {
      hideMenu();
    }
    if (
      states.currentScroll < states.lastScroll &&
      elements.body.classList.contains(classes.scrollDown)
    ) {
      showMenu();
    }

    states.lastScroll = states.currentScroll;
  };

  return {
    init() {
      if (elements.topNav === null) {
        return;
      }
      window.addEventListener('scroll', throttle(applyStickyNav, 100));
    },
  };
})();
